import $ from 'jquery';

export const WALLET_TYPE_APPLE_PAY = 'apple_pay';

/**
 * Normalize a wallet/payment-element type to our internal wallet type.
 *
 * @param {string} raw Payment element type reported by the SDK (e.g. 'card', 'apple_pay').
 *
 * @return {string} 'apple_pay' for any Apple wallet, else the lowercased value.
 */
export const normalizeWalletType = ( raw ) => {
	const value = String( raw || '' ).toLowerCase();
	return value.includes( 'apple' ) ? WALLET_TYPE_APPLE_PAY : value;
};

/**
 * Check whether every visible required field in the form has a value.
 *
 * @param {Object} $form jQuery checkout/order form.
 *
 * @return {boolean} True when all visible required fields are filled.
 */
export const requiredFieldsFilled = ( $form ) => {
	let filled = true;

	$form.find( '.validate-required:visible' ).each( function () {
		const field = $( this ).find( 'input, select, textarea' ).first();
		if ( ! field.length ) {
			return;
		}
		if ( field.attr( 'type' ) === 'checkbox' ) {
			if ( ! field.is( ':checked' ) ) {
				filled = false;
			}
		} else if ( ! String( field.val() || '' ).trim() ) {
			filled = false;
		}
	} );

	return filled;
};

/**
 * Fire pay() inside the Place Order click gesture (no preventDefault), so the wallet sheet opens
 * within the user activation while the checkout's own submit creates the order concurrently.
 *
 * @param {string}   buttonSelector Selector the click target must match (via closest).
 * @param {Function} shouldPay      Returns true when pay() should fire for this click.
 * @param {Function} pay            Synchronous pay handler invoked inside the gesture.
 */
export const registerWalletPayGesture = ( buttonSelector, shouldPay, pay ) => {
	document.addEventListener(
		'click',
		( event ) => {
			if ( event.target.closest( buttonSelector ) && shouldPay() ) {
				pay();
			}
		},
		true
	);
};

/**
 * Resolve once the concurrent checkout has recorded the longId to charge, or null on timeout.
 *
 * @param {Function} getLongId   Returns the current longId to charge (falsy until set).
 * @param {number}   timeoutMs   Max time to wait for the concurrent checkout to finish.
 * @param {number}   intervalMs  Poll interval.
 *
 * @return {Promise<string|null>} The longId to charge, or null if it never arrives.
 */
export const waitForLongId = ( getLongId, timeoutMs = 20000, intervalMs = 100 ) =>
	new Promise( ( resolve ) => {
		if ( getLongId() ) {
			resolve( getLongId() );
			return;
		}

		const start = Date.now();
		const timer = setInterval( () => {
			if ( getLongId() ) {
				clearInterval( timer );
				resolve( getLongId() );
			} else if ( Date.now() - start >= timeoutMs ) {
				clearInterval( timer );
				resolve( null );
			}
		}, intervalMs );
	} );
